export default new class {
  constructor() {

    this.isAuth = !!(document.querySelector('.user-activity__avatar') || document.querySelector('.header__avatar-img'))

    this.addBookmarkMethod = 'onAddBookmark';
    this.deleteBookmarkMethod = 'onDeleteBookmark';
    this.getBookmarksMethod = 'onGetBookmarks';
    this.getBookmarksByArticleMethod = 'onGetArticleBookmarks';

    this.addBookmarkModal = undefined;
    this.tmpBookmarkBtn = undefined;
    this.bookmarksList = [];

    this.bookmarkBtn = undefined
    this.selection = undefined

    if (document.querySelector('[data-bookmark-id]')) {
      this.initCabinet()
      return;
    }

    if (!this.isAuth || !document.querySelector('[data-article-id]')) return;
    this.articleId = document.querySelector('[data-article-id]').dataset.articleId;

    this.init()
  }

  async init() {
    const article = document.querySelector('.article');
    if (article) {
      await this.updateArticleBtns(article)
      this.addBookmarkModal = this.createAddArticleModal()
    }
  }

  mouseUpHandler(event) {
    if (window.getSelection().toString() === this.selection) window.getSelection().removeAllRanges();

    if (this.bookmarkBtn) this.bookmarkBtn.remove();

    if (window.getSelection().toString().length <= 0) return;
    if (window.getSelection().anchorNode.parentElement !== window.getSelection().focusNode.parentElement) return;

    this.selection = window.getSelection().toString()

    const scrollTop = window.scrollY;

    let posX;
    let posY;
    if (event.clientY) {
      posX = event.clientX;
      posY = event.clientY + scrollTop;
    } else {
      posX = event.changedTouches[0].clientX;
      posY = event.changedTouches[0].clientY + scrollTop + 60;
    }

    this.bookmarkBtn = this.createBookmarkBtn();

    this.bookmarkBtn.style.top = posY - 40 + 'px';
    this.bookmarkBtn.style.left = posX - 20 + 'px';
    this.bookmarkBtn.style.position = 'absolute';
    this.bookmarkBtn.id = 'add-bookmark__btn'
    this.bookmarkBtn.style.boxShadow = 'rgba(34, 60, 80, 0.2) 0px 0px 5px 7px';
    this.bookmarkBtn.style.padding = '20px';
    this.bookmarkBtn.style.borderRadius = '100%';
    this.bookmarkBtn.style.backgroundColor = '#fff';

    document.body.appendChild(this.bookmarkBtn)
    document.body.onmousedown = (e) => {
      if (e.target !== this.bookmarkBtn) this.bookmarkBtn.remove();
    }
  }

  async updateArticleBtns() {
    await this.getBookmarkByArticle()
    const createdBookmarks = document.querySelector('.article article').querySelectorAll("span.bookmark-text-item")
    const createdBookmarksId = [];
    createdBookmarks.forEach(createdBookmark => {
      createdBookmarksId.push(+createdBookmark.dataset.bookmarkId)
    })

    this.bookmarksList.forEach(bookmarkItem => {
      if (createdBookmarksId.includes(bookmarkItem.id)) return;

      const article = document.querySelector('.article article');

      const indexOf = article.innerHTML.indexOf(bookmarkItem.bookmark);
      if (indexOf !== -1) {
        const newArticle = article.innerHTML.split(bookmarkItem.bookmark)
        article.innerHTML = newArticle[0] + '<span class="bookmark-text-item" data-bookmark-id="' + bookmarkItem.id + '">' + bookmarkItem.bookmark + '</span>' + newArticle[1]
      }
    })

    this.isMobile = document.body.classList.contains('mobile');

    const bookmarksText = document.querySelectorAll('.bookmark-text-item');
    bookmarksText.forEach(bookmarkText => {
      bookmarkText.onmouseenter = () => {
        if (this.bookmarkBtn) this.bookmarkBtn.remove();

        const posX = event.clientX;
        const posY = bookmarkText.getBoundingClientRect().top + window.scrollY;

        this.bookmarkBtn = this.createBookmarkBtn();
        this.bookmarkBtn.classList.add('solid')
        this.bookmarkBtn.style.top = posY - 40 + 'px';
        this.bookmarkBtn.style.left = posX - 20 + 'px';
        this.bookmarkBtn.style.position = 'absolute';
        this.bookmarkBtn.id = 'add-bookmark__btn'
        this.bookmarkBtn.style.boxShadow = 'rgba(34, 60, 80, 0.2) 0px 0px 5px 7px';
        this.bookmarkBtn.style.padding = '20px';
        this.bookmarkBtn.style.borderRadius = '100%';
        this.bookmarkBtn.style.backgroundColor = '#fff';
        this.bookmarkBtn.onclick = () => {
          this.tmpBookmarkBtn = this.bookmarkBtn;
          this.deleteBookmark(bookmarkText.dataset.bookmarkId)
          const parent = bookmarkText.parentElement;
          parent.innerHTML = parent.innerHTML.replace(bookmarkText.outerHTML, bookmarkText.innerText)
          this.bookmarkBtn.remove()
        }
        document.body.appendChild(this.bookmarkBtn)
      }
    })

    if (this.isMobile) {
      document.querySelector('.article article').ontouchend = (e) => this.mouseUpHandler(e);
    } else {
      document.querySelector('.article article').onmouseup = (e) => this.mouseUpHandler(e);
    }
  }

  initCabinet() {
    const bookmarks = document.querySelectorAll('.personal-data.bookmark-container .bookmark-item')
    bookmarks.forEach((bookmark, index) => {
      this.insertBookmarkBtn(bookmark, index)
    })
  }

  createArticleBookmarksBtn(article) {
    const child = article.querySelector('.article__main article')?.childNodes
    child.forEach((childItem, index) => {
      this.insertBookmarkBtn(childItem, index)
    })
  }

  insertBookmarkBtn(element, index) {
    const articleContainer = document.querySelector('.wysiwyg')

    const bookmarkBtn = document.createElement('span');
    bookmarkBtn.classList.add('bookmark-btn');
    bookmarkBtn.style.top = (element.offsetTop + 2) + 'px'

    bookmarkBtn.onclick = (e) => this.bookmarkBtnClickHandler(e);

    if (articleContainer) {
      bookmarkBtn.onmouseover = this.bookmarkBtnHoverHandler;
      bookmarkBtn.onmouseout = this.bookmarkBtnHoverHandler;
    } else {
      bookmarkBtn.style.right = '0'
    }

    bookmarkBtn.dataset.index = index

    const bookmarkBtnContainer = document.querySelector('.article__main')
      ?? document.querySelector('.personal-data.bookmark-container');

    bookmarkBtnContainer.prepend(bookmarkBtn);

    if (articleContainer) {
      bookmarkBtn.dataset.position = articleContainer.innerHTML.indexOf(element.outerHTML, 0);
    } else {
      bookmarkBtn.dataset.position = element.dataset.position
      bookmarkBtn.style.zIndex = 1
    }

    if (this.bookmarksList && this.bookmarksList.length > 0) {
      const bookmark = this.bookmarksList.find(bookmarkElem => +bookmarkElem.position === +bookmarkBtn.dataset.position)
      if (bookmark) {
        bookmarkBtn.classList.add('solid')
        bookmarkBtn.dataset.bookmarkId = bookmark.id
      }
    } else {
      if (element.dataset.bookmarkId) {
        bookmarkBtn.classList.add('solid')
        bookmarkBtn.dataset.bookmarkId = element.dataset.bookmarkId
      }
    }
  }

  createBookmarkBtn() {
    const bookmarkBtn = document.createElement('span');
    bookmarkBtn.classList.add('bookmark-btn');

    // bookmarkBtn.onclick = (e) => this.bookmarkBtnClickHandler(e);
    bookmarkBtn.onclick = (e) => this.bookmarkBtnClickHandlerNew(e);
    return bookmarkBtn;
  }

  bookmarkBtnClickHandlerNew(e) {
    this.showAddBookmarkModal(this.selection, 1);
    this.bookmarkBtn.remove();
  }

  bookmarkBtnClickHandler(e) {
    const position = e.target.dataset.position
    this.tmpBookmarkBtn = e.target

    if (e.target.classList.contains('solid')) {
      this.deleteBookmark(e.target.dataset.bookmarkId);
    } else {
      if (e.target.parentElement.querySelector('.wysiwyg')) {
        // find element by index
        const element = e.target.parentElement.querySelector('.wysiwyg').childNodes[e.target.dataset.index]
        if (element) {
          this.showAddBookmarkModal(element, position);
        }
      } else {
        if (e.target.dataset.index) {
          const element = document.querySelector('.bookmark-item[data-index="' + e.target.dataset.index + '"]');

          const data = {
            title: element.querySelector('.bookmark-item__title').innerText,
            content: element.querySelector('.bookmark-item__content').innerHTML,
            position: element.dataset.position,
            articleId: element.dataset.articleId
          };
          this.addBookmark(data)
        }
      }
    }
  }

  bookmarkBtnHoverHandler(e) {
    if (e.type === 'mouseout') {
      window.getSelection().removeAllRanges();
    } else {
      const element = e.target.parentElement.querySelector('.wysiwyg').childNodes[e.target.dataset.index]
      const range = document.createRange();
      range.selectNode(element)
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
  }

  createAddArticleModal() {
    const modal = document.createElement('div')
    modal.classList.add('modal')
    modal.classList.add('bookmark__modal')

    const overlay = document.createElement('div')
    overlay.classList.add('overlay')
    overlay.onclick = () => this.hideAddBookmarkModal()
    modal.appendChild(overlay)

    const modalContainer = document.createElement('div')
    modalContainer.classList.add('modal-container')
    modal.appendChild(modalContainer)

    const crossBtn = document.createElement('span')
    crossBtn.classList.add('cross')
    crossBtn.onclick = () => this.hideAddBookmarkModal()
    modalContainer.appendChild(crossBtn)

    const title = document.createElement('p');
    title.classList.add('modal-title');
    title.innerText = 'Создание закладки';
    modalContainer.appendChild(title);

    const inputTitle = document.createElement('input');
    inputTitle.classList.add('modal__bookmark-title');
    inputTitle.value = document.title;
    modalContainer.appendChild(inputTitle);

    const content = document.createElement('div');
    content.classList.add('modal__bookmark-content');
    modalContainer.appendChild(content);

    const submitBtn = document.createElement('button');
    submitBtn.classList.add('button');
    submitBtn.classList.add('_grey');
    // submitBtn.classList.add('btn');
    submitBtn.classList.add('article-bookmark__save-btn');
    submitBtn.innerText = 'Сохранить';
    submitBtn.onclick = () => this.addBookmark();

    modalContainer.appendChild(submitBtn);

    document.body.appendChild(modal);

    return modal;
  }

  showAddBookmarkModal(element, position) {

    this.addBookmarkModal.querySelector('.modal__bookmark-title').value = document.title
    this.addBookmarkModal.style.display = 'flex';
    const contentContainer = this.addBookmarkModal.querySelector('.modal__bookmark-content')

    // remove another elements from container
    while (contentContainer.lastChild) {
      contentContainer.removeChild(contentContainer.lastChild)
    }

    contentContainer.insertAdjacentHTML('beforeend', element);

    contentContainer.dataset.position = position;
  }

  hideAddBookmarkModal() {
    this.addBookmarkModal.style.display = 'none';
  }

  addBookmark(data = {}) {
    const contentContainer = document.querySelector('.modal__bookmark-content');
    const titleInput = document.querySelector('.modal__bookmark-title');
    const articleIdHtml = document.querySelector('[data-article-id]');

    if ((titleInput && contentContainer && articleIdHtml) || data) {
      const title = data.title ?? titleInput.value;
      const contentHtml = data.content ?? contentContainer.innerHTML;
      const contentPosition = data.position ?? contentContainer.dataset.position;
      const articleId = data.articleId ?? this.articleId;

      $.request(this.addBookmarkMethod, {
        data: {
          title: title,
          bookmark: contentHtml,
          position: contentPosition,
          articleId: articleId
        },

        success: async (data) => {
          if (data.status) {
            if (this.addBookmarkModal) this.hideAddBookmarkModal();
            if (this.tmpBookmarkBtn) {
              this.tmpBookmarkBtn.classList.add('solid');
              this.tmpBookmarkBtn.dataset.bookmarkId = data.id;
            }

            const article = document.querySelector('.article');
            await this.updateArticleBtns(article)
          }
        }
      })
    }
  }

  deleteBookmark(bookmarkId) {
    $.request(this.deleteBookmarkMethod, {
      data: {bookmarkId},
      success: (data) => {
        this.tmpBookmarkBtn.classList.remove('solid')
        this.tmpBookmarkBtn.dataset.bookmarkId = '';
      }
    })
  }

  async getBookmarkByArticle() {
    await $.request(this.getBookmarksByArticleMethod, {
      data: {articleId: this.articleId},
      success: (data) => {
        if (data.status) {
          this.bookmarksList = data.bookmarks;
        }
      }
    })
  }
}();
